<template>
  <div>
    <v-dialog v-model="dialog" persistent scrollable max-width="980px">
      <v-card class="modern-payment-dialog">
        <v-card-title class="modern-dialog-header">
          <div>
            <div class="headline font-weight-medium">
              {{ isEditMode
  ? (operationType == 'TAHSILAT' ? $t('Collection-Entry') + ' - ' + $t('Edit') : $t('Payment-Entry') + ' - ' + $t('Edit'))
  : (operationType == 'TAHSILAT' ? $t('Collection-Entry') : $t('Payment-Entry')) }}
            </div>
            <div class="caption grey--text">
              
            </div>
          </div>

          <v-spacer></v-spacer>

          <v-btn icon flat @click="close()">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text class="modern-dialog-body">
          <v-form ref="entryForm" v-model="entryValid" lazy-validation>
            <v-layout row wrap>

              <v-flex xs12 sm12 md12>
                <v-card flat class="modern-section-card">
                  <v-layout row wrap align-center>
                    <v-flex xs12 sm4 md3>
                      <div class="modern-section-title">{{ $t('Transaction-Type') }}</div>
                      <div class="modern-section-subtitle"></div>
                    </v-flex>

                    <v-flex xs12 sm8 md9>
                      <div class="modern-toggle-group">
                        <div
                          :class="modernOperationClass('TAHSILAT')"
                          @click="operationType = 'TAHSILAT'; operationTypeChanged()">
                          <v-icon>trending_up</v-icon>
                          <span>{{ $t('Collection-v3') }}</span>
                        </div>

                        <div
                          v-if="!simpleMode"
                          :class="modernOperationClass('ODEME')"
                          @click="operationType = 'ODEME'; operationTypeChanged()">
                          <v-icon>trending_down</v-icon>
                          <span>{{ $t('Payment-v3') }}</span>
                        </div>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>

              <v-flex xs12 sm12 md12>
                <v-card flat class="modern-section-card">
                  <div class="modern-section-title mb-2">
                    {{ $t('Payment-Method') }}
                  </div>

                  <v-layout row wrap>
                    <v-flex xs12 sm4 md4>
                      <div
                        :class="modernPaymentClass('CASH')"
                        @click="selectPaymentMethod('CASH')">
                        <v-icon>payments</v-icon>
                        <div>
                          <div class="modern-payment-title">{{ $t('Cash-v2') }}</div>
                          <div class="modern-payment-subtitle">{{ $t('Cash-Payment-Description') }}</div>
                        </div>
                      </div>
                    </v-flex>

                    <v-flex xs12 sm4 md4>
                      <div
                        :class="modernPaymentClass('BANK')"
                        @click="selectPaymentMethod('BANK')">
                        <v-icon>account_balance</v-icon>
                        <div>
                          <div class="modern-payment-title">{{ $t('Bank-v2') }}</div>
                          <div class="modern-payment-subtitle">{{ $t('Bank-Payment-Description') }}</div>
                        </div>
                      </div>
                    </v-flex>

                    <v-flex xs12 sm4 md4>
                      <div
                        :class="modernPaymentClass('CARD')"
                        @click="selectPaymentMethod('CARD')">
                        <v-icon>credit_card</v-icon>
                        <div>
                          <div class="modern-payment-title">{{ $t('Credit-Card-v2') }}</div>
                          <div class="modern-payment-subtitle">{{ $t('Credit-Card-Payment-Description') }}</div>
                        </div>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>

              <v-flex xs12 sm12 md12>
                <v-card flat class="modern-section-card">
                  <div class="modern-section-title">{{ $t('Current-Details') }}</div>
                  <div class="modern-section-subtitle mb-2">
                    
                  </div>

                  <v-text-field
                    v-if="simpleMode"
                    hide-details
                    disabled
                    v-model="Movement.Current"
                    :label="$t('Current-Account')">
                  </v-text-field>

                  <cariaracomp
                    v-else
                    v-bind:etiket="$t('Current-Account')"
                    v-bind:value="Movement.Current"
                    v-model="Movement.Current">
                  </cariaracomp>
                </v-card>
              </v-flex>

              <v-flex xs12 sm12 md7>
                <v-card flat class="modern-section-card fill-height">
                  <div class="modern-section-title mb-3">
                    {{ $t('Transaction-Information') }}
                  </div>

                  <v-layout row wrap>
                    <v-flex xs12 sm6 md6>
                      <tarihim
                        :etiket="$t('Date')"
                        :detaygizle="true"
                        v-model="Movement.MovementDate"
                        v-bind:defaultvalue="'ok'"
                        :rules="[v => !!v || $t('Please-select-a-date')]">
                      </tarihim>
                    </v-flex>

                    <v-flex xs12 sm6 md6>
                      <v-text-field
                        hide-details
                        disabled
                        v-model="Movement.DocumentNumber"
                        :label="$t('Document-No')"
                        :placeholder="$t('Receipt-Will-Be-Created-Automatically')">
                      </v-text-field>
                    </v-flex>

                    <v-flex xs12 sm6 md6 v-if="paymentMethod == 'BANK'">
                      <div class="bank-code-add-row">
                        <div class="bank-code-field">
                          <bankakodu
                            :key="'bank-code-' + bankCodeComponentKey"
                            v-model="Movement.BankCode">
                          </bankakodu>
                        </div>

                        <v-tooltip top>
                          <v-btn
                            slot="activator"
                            color="info"
                            fab
                            small
                            dark
                            class="bank-code-add-button"
                            @click.stop="openBankAddDialog">
                            <v-icon>add</v-icon>
                          </v-btn>
                          <span>{{ $t('Add-Bank') }}</span>
                        </v-tooltip>
                      </div>
                    </v-flex>

                    <v-flex xs12 sm6 md6 v-if="paymentMethod == 'CARD' && operationType == 'TAHSILAT'">
                      <div class="pos-code-add-row">
                        <div class="pos-code-field">
                          <v-autocomplete
                            :items="bankapositems"
                            hide-details
                            v-model="Movement.PosCode"
                            item-text="Title"
                            item-value="PosKodu"
                            clearable
                            :label="$t('Pos-Code')">
                          </v-autocomplete>
                        </div>

                        <v-tooltip top>
                          <v-btn
                            slot="activator"
                            color="info"
                            fab
                            small
                            dark
                            class="pos-code-add-button"
                            @click.stop="openPosAddDialog">
                            <v-icon>add</v-icon>
                          </v-btn>
                          <span>{{ $t('Add-v2', { value: $t('Bank-POS') }) }}</span>
                        </v-tooltip>
                      </div>
                    </v-flex>

                    <v-flex xs12 sm6 md6 v-if="paymentMethod == 'CARD' && operationType == 'ODEME'">
                      <kredikartcomp v-model="Movement.FirmCardNumber"></kredikartcomp>
                    </v-flex>

                    <v-flex xs12 sm6 md6 v-if="paymentMethod == 'CARD'">
                      <v-text-field
                        hide-details
                        v-model="Movement.CardNumber"
                        label="Kart No">
                      </v-text-field>
                    </v-flex>

                    <v-flex xs12 sm6 md6>
                      <parainput
                        :simge="getparabirimi()"
                        v-model="Movement.Amount"
                        :etiket="$t('Amount')"
                        :autocomplete="'autocomplete'"
                        @input="exchangeAmountCalculate">
                      </parainput>
                    </v-flex>

                    <v-flex xs12 sm6 md6>
                      <v-text-field
                        v-if="simpleMode"
                        hide-details
                        disabled
                        v-model="Movement.ExchangeType"
                        :label="$t('Currency-Type')">
                      </v-text-field>

                      <v-autocomplete
                        v-else
                        :items="doviztipi"
                        item-text="Title"
                        item-value="DovizKod"
                        hide-details
                        :clearable="!currencyForced"
                        :disabled="currencyForced"
                        v-model="Movement.ExchangeType"
                        :label="$t('Currency-Type')"
                        @change="kurgetir(Movement.ExchangeType)">
                      </v-autocomplete>
                    </v-flex>

                    <v-flex xs12 sm6 md6 v-if="!simpleMode">
                      <v-text-field
                        hide-details
                        type="number"
                        v-model="Movement.ExchangeRate"
                        :disabled="currencyForced"
                        :label="$t('Exchange-Rate')"
                        @input="exchangeAmountCalculate">
                      </v-text-field>
                    </v-flex>

                    <v-flex xs12 sm6 md6>
                      <v-text-field
                        v-if="simpleMode"
                        hide-details
                        disabled
                        type="number"
                        v-model="Movement.ExchangeAmount"
                        :label="$t('Currency-Amount')">
                      </v-text-field>

                      <parainput
                        v-else
                        :simge="Movement.ExchangeType || getparabirimi()"
                        v-model="Movement.ExchangeAmount"
                        :etiket="$t('Currency-Amount')"
                        :autocomplete="'autocomplete'">
                      </parainput>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>

              <v-flex xs12 sm12 md5>
                <v-card flat class="modern-section-card fill-height">
                  <div class="modern-section-title mb-3">
                    {{ $t('EXPLANATION') }}
                  </div>

                  <v-textarea
                    hide-details
                    rows="10"
                    no-resize
                    v-model="Movement.Explanation"
                    :label="$t('Description')"
                    maxlength="250">
                  </v-textarea>

                  <v-alert class="mt-3" :value="true" type="info" outline>
                    {{ $t('Receipt-Will-Be-Created-Automatically') }}
                  </v-alert>
                </v-card>
              </v-flex>

              <v-flex xs12 sm12 md12 v-if="!simpleMode">
                <v-card flat class="modern-section-card">
                  <div class="modern-extra-header" @click="extraOptionsOpen = !extraOptionsOpen">
                    <div>
                      <div class="modern-section-title">
                        {{ $t('Additional-Features') }}
                      </div>
                      <div class="modern-section-subtitle">
                        {{ $t('Additional-Features-Description') }}
                      </div>
                    </div>

                    <v-btn icon flat>
                      <v-icon>{{ extraOptionsOpen ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</v-icon>
                    </v-btn>
                  </div>

                  <v-expand-transition>
                    <div v-show="extraOptionsOpen" class="modern-extra-content">
                      <v-layout row wrap>
                        <v-flex xs12 sm4 md4>
                          <masrafmerkezicomp
                            :detaygizle="'true'"
                            v-model="Movement.ExpenseCenter">
                          </masrafmerkezicomp>
                        </v-flex>

                        <v-flex xs12 sm4 md4>
                          <referansmerkezicomp
                            :coper="false"
                            :tabdeger="'37'"
                            v-model="Movement.Reference">
                          </referansmerkezicomp>
                        </v-flex>

                        <v-flex xs12 sm4 md4>
                          <muhasebekoducomp
                            :etiket="$t('Accounting-Code')"
                            v-model="Movement.ContraAccount">
                          </muhasebekoducomp>
                        </v-flex>
                      </v-layout>
                    </div>
                  </v-expand-transition>
                </v-card>
              </v-flex>

            </v-layout>
          </v-form>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="modern-dialog-actions">
          <v-spacer></v-spacer>

          <v-btn color="grey darken-1" flat @click="close()">
            {{ $t('cancel_button') }}
          </v-btn>

          <v-btn color="info" :loading="saveLoading" :disabled="saveLoading" @click="saveEntry(false)">
            {{ $t('save_button') }}
          </v-btn>

          <v-btn
            v-if="!simpleMode"
            color="success"
            :loading="saveLoading"
            :disabled="saveLoading"
            @click="saveEntry(true)">
            {{ $t('Save-And-Download-Receipt') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="bankAddDialog" persistent max-width="500px">
      <v-card color="grey lighten-5">
        <v-toolbar dark color="info">
          <v-toolbar-title>{{ $t('Add-Bank') }}</v-toolbar-title>
        </v-toolbar>

        <v-card-text>
          <v-form ref="bankAddForm" v-model="bankAddValid" lazy-validation>
            <v-text-field
              v-model.trim="BankAdd.BankCode"
              :label="$t('Bank-Code')"
              :rules="[v => !!v || $t('Mandatory-Areas')]"
              maxlength="20">
            </v-text-field>

            <v-text-field
              v-model.trim="BankAdd.BankName"
              :label="$t('Bank-Name')"
              :rules="[v => !!v || $t('Mandatory-Areas')]"
              maxlength="100">
            </v-text-field>

            <v-text-field
              v-model.trim="BankAdd.BankShortName"
              :label="$t('Bank-Short-Code')"
              maxlength="100">
            </v-text-field>

            <cariaracomp
              v-bind:etiket="$t('Select-Current')"
              v-bind:value="BankAdd.Account"
              v-model="BankAdd.Account">
            </cariaracomp>
          </v-form>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="grey darken-1"
            flat
            :disabled="bankAddLoading"
            @click="closeBankAddDialog">
            {{ $t('cancel_button') }}
          </v-btn>

          <v-btn
            color="info"
            flat
            :loading="bankAddLoading"
            :disabled="bankAddLoading"
            @click="saveBankAdd">
            {{ $t('save_button') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="posAddDialog" persistent max-width="500px">
      <v-card color="grey lighten-5">
        <v-toolbar dark color="info">
          <v-toolbar-title>
            {{ $t('Add-v2', { value: $t('Bank-POS') }) }}
          </v-toolbar-title>
        </v-toolbar>

        <v-card-text>
          <v-form ref="posAddForm" v-model="posAddValid" lazy-validation>
            <v-text-field
              v-model.trim="PosAdd.PosCode"
              :label="$t('Pos-Code')"
              :rules="[
                v => !!v || $t('Mandatory-Areas'),
                v => !v || v.toString().length <= 100 || 'POS kodu en fazla 100 karakter olabilir.'
              ]"
              maxlength="100"
              counter="100">
            </v-text-field>

            <v-text-field
              v-model.trim="PosAdd.Explanation"
              :label="$t('Description')"
              :rules="[v => !!v || $t('Mandatory-Areas')]"
              maxlength="150">
            </v-text-field>

          </v-form>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="grey darken-1"
            flat
            :disabled="posAddLoading"
            @click="closePosAddDialog">
            {{ $t('cancel_button') }}
          </v-btn>

          <v-btn
            color="info"
            flat
            :loading="posAddLoading"
            :disabled="posAddLoading"
            @click="savePosAdd">
            {{ $t('save_button') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar
      :timeout="timeout"
      :top="y === 'top'"
      :bottom="y === 'bottom'"
      :right="x === 'right'"
      :left="x === 'left'"
      :multi-line="mode === 'multi-line'"
      :vertical="mode === 'vertical'"
      v-model="snackbar">
      {{ text1 }}
      <v-btn flat color="pink" @click.native="snackbar = false">
        {{ $t('Close') }}
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import auth from '../../../../api/auth'
import parainput from '../../customcomp/parainput'
import tarihim from '../../customcomp/tarihim'
import cariaracomp from '@/components/app/customcomp/cariaracomp.vue'
import bankakodu from '@/components/app/customcomp/bankakodu'
import kredikartcomp from '@/components/app/bilet/partpage/kredikartcomp.vue'
import masrafmerkezicomp from '@/components/app/bilet/partpage/masrafmerkezicomp.vue'
import referansmerkezicomp from '@/components/app/bilet/partpage/referanscomp.vue'
import muhasebekoducomp from '@/components/app/customcomp/muhasebekoducomp.vue'
import tool from '../tools'

function getCredentialsCurrency() {
  try {
    var credentialsText = window.localStorage.getItem('credentials')

    if (!credentialsText) {
      console.error('credentials localStorage içerisinde bulunamadı.')
      return ''
    }

    var credentials = JSON.parse(credentialsText)
    var currency =
      credentials &&
      credentials.ParaBirimi !== undefined &&
      credentials.ParaBirimi !== null
        ? credentials.ParaBirimi
        : credentials &&
          credentials.paraBirimi !== undefined &&
          credentials.paraBirimi !== null
          ? credentials.paraBirimi
          : ''

    return currency !== undefined && currency !== null
      ? currency.toString().trim()
      : ''
  } catch (error) {
    console.error('credentials para birimi okunamadı:', error)
    return ''
  }
}

export default {
  data() {
    return {
      dialog: false,
      entryValid: true,
      saveLoading: false,
      isEditMode: false,
      operationType: 'TAHSILAT',
      paymentMethod: 'CASH',
      extraOptionsOpen: false,
      currencyForced: false,
      simpleMode: false,
      pnrNo: null,

      Movement: this.getDefaultMovement(),

      evraktipi: [],
      doviztipi: [],
      bankapositems: [],

      bankAddDialog: false,
      bankAddValid: true,
      bankAddLoading: false,
      bankCodeComponentKey: 0,
      BankAdd: this.getDefaultBankAdd(),

      posAddDialog: false,
      posAddValid: true,
      posAddLoading: false,
      PosAdd: this.getDefaultPosAdd(),

      snackbar: false,
      y: 'top',
      x: 'right',
      mode: '',
      timeout: 6000,
      text1: ''
    }
  },

  methods: {
    getDefaultBankAdd() {
      return {
        CompanyCode: null,
        BankCode: '',
        BankName: '',
        BankShortName: '',
        Account: null
      }
    },

    getDefaultPosAdd() {
      return {
        PosCode: '',
        Explanation: ''
      }
    },

    getDefaultPosCodes() {
      return {
        MuhasebeKodu: '',
        CMuhasebeKodu: '',
        FDisAktarimCariKodu: '',
        FDisAktarimMuhKodu: '',
        CDisAktarimCariKodu: '',
        CDisAktarimMuhKodu: '',
        ServisMuhasebeKodu: '',
        ServisDisAktarimCariKodu: '',
        ServisDisAktarimMuhKodu: ''
      }
    },

    getDefaultPosParameters() {
      return {
        Banka: {
          BankaKod: ''
        },
        ID: '',
        PosMuhKodu: '',
        PuanCariKodu: '',
        SozlesmeBaslangic: null,
        SozlesmeBitis: null,
        Aktif: '1',
        VadeTip: '0',
        UyelikTutar: 0,
        UyelikOran: 0,
        Kota: 0,
        KotaGun: 0,
        KotaCezaTutar: 0,
        KotaCezaOran: 0,
        VadeSabitGun: null,
        VadeFarkSabit: 1,
        KotaKod: '',
        TerminalID: '',
        UyeIsYeriID: '',
        UserName: '',
        UserPass: '',
        PosType: 0,
        StoreKey: ''
      }
    },

    openPosAddDialog() {
      this.PosAdd = this.getDefaultPosAdd()
      this.posAddValid = true
      this.posAddLoading = false
      this.posAddDialog = true

      this.$nextTick(() => {
        if (this.$refs.posAddForm) {
          this.$refs.posAddForm.resetValidation()
        }
      })
    },

    closePosAddDialog() {
      if (this.posAddLoading) {
        return
      }

      this.posAddDialog = false
      this.PosAdd = this.getDefaultPosAdd()
      this.posAddValid = true
    },

    createDefaultPosInstallments(companyCode, posCode) {
      var failedInstallments = []
      var sequence = Promise.resolve()

      for (var installmentNumber = 1; installmentNumber <= 12; installmentNumber++) {
        ((number) => {
          sequence = sequence.then(() => {
            var installmentParams = {
              CompanyCode: companyCode,
              PosCode: posCode,
              InsExplanation: number + ' Taksit',
              InsNumber: number,
              ExpiryDifPercent: 0,
              ExpiryDifAmount: 0,
              PointPercent: 0,
              PointAmount: 0,
              ExpiryDifPercentSales: 0,
              ExpiryDifAmountSales: 0,
              PointPercentSales: 0,
              PointAmountSales: 0
            }

            return this.$http.post(auth.API_URL + 'api/BankPos/InsAdd', installmentParams, {
              headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
              }
            }).then((response) => {
              if (!response.body || response.body.Status !== true) {
                failedInstallments.push(number)
              }
            }, () => {
              failedInstallments.push(number)
            })
          })
        })(installmentNumber)
      }

      return sequence.then(() => {
        return failedInstallments
      })
    },

    savePosAdd() {
      if (!this.$refs.posAddForm || !this.$refs.posAddForm.validate()) {
        return
      }

      var credentials = JSON.parse(window.localStorage.getItem('credentials'))
      var posCode = (this.PosAdd.PosCode || '').toString().trim()
      var explanation = (this.PosAdd.Explanation || '').toString().trim()

      if (!posCode || !explanation) {
        this.text1 = this.$t('Mandatory-Areas')
        this.snackbar = true
        return
      }

      if (posCode.length > 100) {
        this.text1 = 'POS kodu en fazla 100 karakter olabilir.'
        this.snackbar = true
        return
      }

      var exists = (this.bankapositems || []).some(item => {
        var currentPosCode = item && item.PosKodu != null
          ? item.PosKodu.toString().trim().toLowerCase()
          : ''

        return currentPosCode == posCode.toLowerCase()
      })

      if (exists) {
        this.text1 = 'Bu POS kodu zaten tanımlı.'
        this.snackbar = true
        return
      }

      var params = {
        CompanyCode: credentials.SirketKodu,
        PosCode: posCode,
        Explaniton: explanation,
        Codes: this.getDefaultPosCodes(),
        Parameters: this.getDefaultPosParameters()
      }

      this.posAddLoading = true

      this.$http.post(auth.API_URL + 'api/BankPos/Add', params, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {
        if (!response.body || response.body.Status !== true) {
          this.posAddLoading = false
          this.text1 = response.body && response.body.ResponseMessage
            ? this.$t(response.body.ResponseMessage)
            : 'POS kaydedilemedi.'
          this.snackbar = true
          return
        }

        this.createDefaultPosInstallments(credentials.SirketKodu, posCode).then((failedInstallments) => {
          this.loadBankPosList().then(() => {
            this.posAddLoading = false
            this.Movement.PosCode = posCode
            this.posAddDialog = false
            this.PosAdd = this.getDefaultPosAdd()

            if (failedInstallments.length == 0) {
              this.text1 = 'POS kaydedildi.'
            } else {
              this.text1 =
                'POS kaydedildi. Oluşturulamayan taksitler: ' +
                failedInstallments.join(', ')
            }

            this.snackbar = true
          })
        })
      }, (response) => {
        this.posAddLoading = false

        if (response && response.body && response.body.ExceptionMessage) {
          this.text1 = response.body.ExceptionMessage
        } else if (response && response.body && response.body.ResponseMessage) {
          this.text1 = this.$t(response.body.ResponseMessage)
        } else if (response && response.statusText) {
          this.text1 = response.statusText
        } else {
          this.text1 = 'POS kaydedilemedi.'
        }

        this.snackbar = true
      })
    },

    openBankAddDialog() {
      this.BankAdd = this.getDefaultBankAdd()
      this.bankAddValid = true
      this.bankAddLoading = false
      this.bankAddDialog = true

      this.$nextTick(() => {
        if (this.$refs.bankAddForm) {
          this.$refs.bankAddForm.resetValidation()
        }
      })
    },

    closeBankAddDialog() {
      if (this.bankAddLoading) {
        return
      }

      this.bankAddDialog = false
      this.BankAdd = this.getDefaultBankAdd()
      this.bankAddValid = true
    },

    saveBankAdd() {
      if (!this.$refs.bankAddForm || !this.$refs.bankAddForm.validate()) {
        return
      }

      var credentials = JSON.parse(window.localStorage.getItem('credentials'))
      var bankCode = (this.BankAdd.BankCode || '').toString().trim()
      var bankName = (this.BankAdd.BankName || '').toString().trim()
      var bankShortName = (this.BankAdd.BankShortName || '').toString().trim()
      var accountCode = this.getCurrentCode(this.BankAdd.Account)

      if (!bankCode || !bankName) {
        this.text1 = this.$t('Mandatory-Areas')
        this.snackbar = true
        return
      }

      var params = {
        CompanyCode: credentials.SirketKodu,
        BankCode: bankCode,
        BankName: bankName,
        BankShortName: bankShortName,
        Account: accountCode || null
      }

      this.bankAddLoading = true

      this.$http.post(auth.API_URL + 'api/Bank/Add', params, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {
        this.bankAddLoading = false

        if (response.body && response.body.Status === true) {
          this.Movement.BankCode = bankCode
          this.bankAddDialog = false
          this.BankAdd = this.getDefaultBankAdd()
          this.bankCodeComponentKey += 1
          this.text1 = this.$t('Update-completed')
          this.snackbar = true
          return
        }

        this.text1 = response.body && response.body.ResponseMessage
          ? this.$t(response.body.ResponseMessage)
          : 'Banka kaydedilemedi.'
        this.snackbar = true
      }, (response) => {
        this.bankAddLoading = false

        if (response && response.body && response.body.ExceptionMessage) {
          this.text1 = response.body.ExceptionMessage
        } else if (response && response.statusText) {
          this.text1 = response.statusText
        } else {
          this.text1 = 'Banka kaydedilemedi.'
        }

        this.snackbar = true
      })
    },

    open(params) {
      params = params || {}
      this.simpleMode = params.simpleMode === true
      this.pnrNo = params.pnrNo || params.PNR_No || params.pNR_No || null
      this.isEditMode = this.simpleMode ? false : params.isEditMode === true
      this.operationType = this.simpleMode ? 'TAHSILAT' : (params.operationType || 'TAHSILAT')
      this.paymentMethod = params.paymentMethod || 'CASH'
      this.extraOptionsOpen = false
      this.currencyForced = this.simpleMode || params.forceCurrency === true
      this.Movement = this.getDefaultMovement()

      this.Movement.Current = params.currentCode || params.current || ''
      this.Movement.Amount = Number(params.amount || 0)
      this.Movement.GrossAmount = Number(params.amount || 0)
      this.Movement.MovementDate = params.date || this.getDateNow()
      this.Movement.MovementDueDate = params.dueDate || params.date || this.getDateNow()
      this.Movement.Explanation = params.explanation || ''

      this.Movement.DocumentType = params.documentType || this.Movement.DocumentType
this.Movement.DocumentNumber = params.documentNumber || ''

this.Movement.ExchangeType = params.exchangeType || this.Movement.ExchangeType
this.Movement.ExchangeRate = params.exchangeRate || this.Movement.ExchangeRate || 1
this.Movement.ExchangeAmount = params.exchangeAmount || this.Movement.ExchangeAmount || Number(params.amount || 0)

if (this.currencyForced || this.simpleMode) {
  this.Movement.ExchangeType = params.exchangeType || getCredentialsCurrency()
  this.Movement.ExchangeRate = 1
  this.Movement.ExchangeAmount = Number(params.amount || 0)
}

this.Movement.BankCode = params.bankCode || null
this.Movement.PosCode = params.posCode || null
this.Movement.FirmCardNumber = params.firmCardNumber || null

this.Movement.OrderNumber = params.orderNumber || 0
this.Movement.OldCurrent = params.oldCurrent || params.currentCode || params.current || ''
this.Movement.OldMovementDate = params.oldMovementDate || params.date || null
this.Movement.OldOrderNumber = params.oldOrderNumber || params.orderNumber || 0

      if (params.reference) {
        this.Movement.Reference = params.reference
        this.extraOptionsOpen = true
      }

      if (params.expenseCenter) {
        this.Movement.ExpenseCenter = params.expenseCenter
        this.extraOptionsOpen = true
      }

      if (params.accountingCode) {
        this.Movement.ContraAccount = params.accountingCode
        this.extraOptionsOpen = true
      }

      this.operationTypeChanged()
      this.paymentMethodChanged()
      this.exchangeAmountCalculate()

      if (this.evraktipi.length == 0 || this.doviztipi.length == 0) {
        this.loadDefinitions()
      }

      this.dialog = true
    },

    close() {
  this.dialog = false
  this.saveLoading = false
  this.isEditMode = false
  this.currencyForced = false
  this.simpleMode = false
  this.pnrNo = null
  this.Movement = this.getDefaultMovement()
},

    getDefaultMovement() {
      return {
        Current: '',
        MovementDate: null,
        MovementDueDate: null,
        DocumentType: '',
        DocumentNumber: '',
        Explanation: '',
        DebitCredit: '',
        Amount: 0,
        ExchangeType: '',
        ExchangeRate: 1,
        ExchangeAmount: 0,
        ContraDocumentType: '',
        ContraDocumentNumber: '',
        ContraCurrent: 0,
        ContraExplanation: '',
        ContraExchangeType: '',
        ContraExchangeRate: 0,
        ContraExchangeAmount: 0,
        PaymentCode: '',
        Reference: '',
        ExpenseCenter: null,
        CompanyCode: '',
        ReceiptType: '',
        FirmCardNumber: null,
        CardNumber: null,
        PosCode: null,
        InstallmentID: null,
        InstallmentExplanation: null,
        GrossAmount: 0,
        TaxAmount: 0,
        DiscountAmount: 0,
        ContraAccount: null,
        BankCode: null,
        AccountingIntegration: true,
        OrderNumber: 0,
        OldCurrent: '',
        OldMovementDate: null,
        OldOrderNumber: 0
      }
    },

    getDateNow() {
      var today = new Date()
      var dd = today.getDate()
      var mm = today.getMonth() + 1
      var yyyy = today.getFullYear()

      if (dd < 10) {
        dd = '0' + dd
      }

      if (mm < 10) {
        mm = '0' + mm
      }

      return yyyy + '-' + mm + '-' + dd
    },

    getparabirimi() {
      return getCredentialsCurrency()
    },

    getCurrentCode(current) {
      if (current == null) {
        return ''
      }

      if (typeof current == 'object') {
        return current.Kod || current.kod || current.id || current.Id || current.CariKodu || current.CariKod || ''
      }

      return current
    },

    selectPaymentMethod(method) {
      this.paymentMethod = method
      this.paymentMethodChanged()
    },

    modernPaymentClass(method) {
      return {
        'modern-payment-method-card': true,
        'modern-payment-method-card-active': this.paymentMethod == method
      }
    },

    modernOperationClass(type) {
      return {
        'modern-operation-item': true,
        'modern-operation-item-active': this.operationType == type
      }
    },

    operationTypeChanged() {
      if (this.simpleMode) {
        this.operationType = 'TAHSILAT'
      }

      if (this.operationType == 'TAHSILAT') {
        this.Movement.DebitCredit = 'A'
        this.Movement.ReceiptType = '1'
      } else {
        this.Movement.DebitCredit = 'B'
        this.Movement.ReceiptType = '2'
      }

      if (!this.isEditMode) {
  this.Movement.DocumentNumber = null
}
    },

    paymentMethodChanged() {
      if (this.paymentMethod == 'CASH') {
        this.Movement.DocumentType = this.findDocumentType(['NK'], 'NK')
      }

      if (this.paymentMethod == 'BANK') {
        this.Movement.DocumentType = this.findDocumentType(['HV'], 'HV')
      }

      if (this.paymentMethod == 'CARD') {
        this.Movement.DocumentType = this.findDocumentType(['KK', 'POS', 'KART', 'CC'], 'KK')
      }

      if (this.paymentMethod != 'BANK') {
        this.Movement.BankCode = null
      }

      if (this.paymentMethod != 'CARD') {
        this.Movement.PosCode = null
        this.Movement.FirmCardNumber = null
        this.Movement.CardNumber = null
      }

      if (!this.isEditMode) {
  this.Movement.DocumentNumber = null
}
    },

    findDocumentType(codes, fallback) {
      if (!this.evraktipi || this.evraktipi.length == 0) {
        return fallback
      }

      for (var i = 0; i < codes.length; i++) {
        var found = this.evraktipi.find(x => x.Evrakkod == codes[i])

        if (found) {
          return found.Evrakkod
        }
      }

      return fallback
    },

    exchangeAmountCalculate() {
      var amount = Number(this.Movement.Amount || 0)

      if (this.currencyForced || this.simpleMode) {
        this.Movement.ExchangeRate = 1
        this.Movement.ExchangeAmount = amount
        return
      }

      var rate = Number(this.Movement.ExchangeRate || 1)

      if (rate == 0) {
        rate = 1
      }

      this.Movement.ExchangeAmount = amount * rate
    },

    kurgetir(kod) {
      if (this.currencyForced || this.simpleMode) {
        this.Movement.ExchangeType = getCredentialsCurrency()
        this.Movement.ExchangeRate = 1
        this.Movement.ExchangeAmount = Number(this.Movement.Amount || 0)
        return
      }

      if (kod == null || kod == '') {
        return
      }

      var params = {
        Tarih: this.Movement.MovementDate,
        DovizKod: kod
      }

      this.$http.post(auth.API_URL + 'api/Definitions/GetWebRate', params, {
        headers: auth.getAuthCompaniesInfo()
      }).then((response) => {
        if (response.body == 0.0) {
          this.Movement.ExchangeRate = 1
        } else {
          this.Movement.ExchangeRate = response.body
        }

        this.exchangeAmountCalculate()
      }, () => {
        this.text1 = 'Service Unavailable-Kur Hesapla'
        this.snackbar = true
      })
    },

    getSimplePaymentType() {
      if (this.paymentMethod == 'CARD') {
        return 1
      }

      if (this.paymentMethod == 'BANK') {
        return 2
      }

      return 0
    },

    getSimpleBankCode(value) {
      if (value == null) {
        return ''
      }

      if (typeof value == 'object') {
        return value.BankaKod || value.bankaKod || value.BankCode || value.bankCode || value.Kod || value.kod || value.id || ''
      }

      return value
    },

    getSimplePosCode(value) {
      if (value == null) {
        return ''
      }

      if (typeof value == 'object') {
        return value.PosKodu || value.posKodu || value.PosCode || value.posCode || value.Kod || value.kod || value.id || ''
      }

      return value
    },

    buildSimplePnrPaymentRequest(activeCurrency) {
      var paymentType = this.getSimplePaymentType()
      var bankCode = this.getSimpleBankCode(this.Movement.BankCode)
      var posCode = this.getSimplePosCode(this.Movement.PosCode)

      return {
        OdemeTarihi: this.Movement.MovementDate,
        OdemeTipi: paymentType,
        NakitBilgi: {
          KarsiCari: null,
          KarsiCariAciklama: null
        },
        KrediKartBilgi: {
          KarsiCari: null,
          KarsiCariAciklama: null,
          KartNo: this.Movement.CardNumber || null,
          KartAdi: null,
          KartTipi: 0,
          Banka: bankCode || null,
          Taksit: 1,
          PosKodu: posCode || null,
          PosTaksit: Number(this.Movement.InstallmentID || 0),
          PuanTutari: 0
        },
        HavaleBilgi: {
          Banka: bankCode || null,
          Aciklama: this.Movement.Explanation || null
        },
        SanalPosBilgi: {
          KarsiCari: null,
          KarsiCariAciklama: null
        },
        Tutar: Number(this.Movement.Amount || 0),
        ParaBirimi: activeCurrency,
        Kur: 1,
        OdemeIadesi: false,
        PNR_No: Number(this.pnrNo) || this.pnrNo,
        EvrakNo: this.Movement.DocumentNumber || null,
        Aciklama: this.Movement.Explanation || null,
        EmptyReturn: false,
        SimpleMode: true
      }
    },

    saveSimplePnrPayment(currentCode, activeCurrency) {
      if (!this.pnrNo || Number(this.pnrNo) <= 0) {
        this.text1 = "Tahsilatın bağlanacağı PNR bulunamadı."
        this.snackbar = true
        return
      }

      this.operationType = 'TAHSILAT'
      this.Movement.ExchangeType = activeCurrency
      this.Movement.ExchangeRate = 1
      this.Movement.ExchangeAmount = Number(this.Movement.Amount || 0)

      var params = this.buildSimplePnrPaymentRequest(activeCurrency)

      this.saveLoading = true

      tool.http_post(this, 'OdemeKaydet', params).then(
        response => {
          this.saveLoading = false

          if (response.body && response.body.Status === true) {
            var payments = Array.isArray(response.body.data)
              ? response.body.data
              : []

            this.text1 = response.body.ResponseMessage || 'Kayıt Edildi.'
            this.snackbar = true

            this.$emit('saved', {
              response: response.body,
              movement: params,
              payments: payments,
              simpleMode: true,
              currentCode: currentCode
            })

            this.close()
            return
          }

          this.text1 =
            response.body &&
            response.body.ErrorList &&
            response.body.ErrorList.length
              ? response.body.ErrorList[0]
              : 'Tahsilat kaydedilemedi.'
          this.snackbar = true
        },
        response => {
          this.saveLoading = false

          if (response && response.body && response.body.ExceptionMessage) {
            this.text1 = response.body.ExceptionMessage
          } else if (
            response &&
            response.body &&
            response.body.ErrorList &&
            response.body.ErrorList.length
          ) {
            this.text1 = response.body.ErrorList[0]
          } else {
            this.text1 = 'Service Unavailable - OdemeKaydet'
          }

          this.snackbar = true
        }
      )
    },

    saveEntry(downloadAfterSave) {
      if (!this.$refs.entryForm.validate()) {
        return
      }

      var credentials = JSON.parse(window.localStorage.getItem('credentials'))
      var currentCode = this.getCurrentCode(this.Movement.Current)

      if (currentCode == null || currentCode == '') {
        this.text1 = this.$t('Please-choose')
        this.snackbar = true
        return
      }

      if (this.Movement.Amount == null || Number(this.Movement.Amount) <= 0) {
        this.text1 = this.$t('Please-enter-amount-v2')
        this.snackbar = true
        return
      }

      var activeCurrency = getCredentialsCurrency()

      if (!activeCurrency) {
        this.text1 = 'Kullanıcı para birimi bulunamadı.'
        this.snackbar = true
        return
      }

      if (this.currencyForced || this.simpleMode) {
        this.Movement.ExchangeType = activeCurrency
        this.Movement.ExchangeRate = 1
        this.Movement.ExchangeAmount = Number(this.Movement.Amount || 0)
      } else if (this.Movement.ExchangeType == null || this.Movement.ExchangeType == '') {
        this.Movement.ExchangeType = activeCurrency
        this.Movement.ExchangeRate = 1
        this.Movement.ExchangeAmount = Number(this.Movement.Amount || 0)
      }

      if (this.simpleMode) {
        this.saveSimplePnrPayment(currentCode, activeCurrency)
        return
      }

      this.operationTypeChanged()
this.paymentMethodChanged()

var isUpdate =
  this.isEditMode === true ||
  Number(this.Movement.OrderNumber || 0) > 0

var currentMovement = JSON.parse(JSON.stringify(this.Movement))
currentMovement.CompanyCode = credentials.SirketKodu
currentMovement.Current = currentCode

if (isUpdate) {
  currentMovement.DocumentNumber = this.Movement.DocumentNumber
  currentMovement.OrderNumber = Number(this.Movement.OrderNumber || 0)
  currentMovement.OldCurrent = this.Movement.OldCurrent || currentCode
  currentMovement.OldMovementDate = this.Movement.OldMovementDate || this.Movement.MovementDate
  currentMovement.OldOrderNumber = Number(this.Movement.OldOrderNumber || this.Movement.OrderNumber || 0)
} else {
  currentMovement.DocumentNumber = null
}

currentMovement.GrossAmount = this.Movement.Amount
currentMovement.DiscountAmount = 0
currentMovement.TaxAmount = 0
currentMovement.TaxRate = 0

      if (!this.extraOptionsOpen) {
        currentMovement.Reference = null
        currentMovement.ExpenseCenter = null
        currentMovement.ContraAccount = null
      }

      this.saveLoading = true

var apiUrl = isUpdate
  ? auth.API_URL + 'api/CurrentMovement/update'
  : auth.API_URL + 'api/CurrentMovement/New'

console.log('TAHSILAT_ODEME_SAVE_MODE', {
  isEditMode: this.isEditMode,
  isUpdate: isUpdate,
  orderNumber: currentMovement.OrderNumber,
  oldOrderNumber: currentMovement.OldOrderNumber,
  apiUrl: apiUrl
})

this.$http.post(apiUrl, currentMovement, {
  headers: {
    'Authorization': 'Bearer ' + auth.getAuthHeader()
  }
}).then((response) => {
  this.saveLoading = false

  this.text1 = this.$t(response.body.ResponseMessage)
  this.snackbar = true

        if (response.body.Status == true) {
          var sirano = isUpdate ? currentMovement.OrderNumber : null

if (!isUpdate && response.body.CariResponse && response.body.CariResponse.Sirano) {
  sirano = response.body.CariResponse.Sirano
}

          var pdfParams = {
            CompanyCode: credentials.SirketKodu,
            Date: this.Movement.MovementDate,
            AccountCode: currentCode,
            OrderNumber: sirano
          }

          this.$emit('saved', {
            response: response.body,
            movement: currentMovement,
            pdfParams: pdfParams
          })

          this.close()

          if (downloadAfterSave == true && sirano != null) {
            this.downloadReceiptPdf(pdfParams, currentMovement.DebitCredit)
          }
        }
      }, (response) => {
        this.saveLoading = false

        if (response.status === 0) {
          this.text1 = 'Service Unavailable'
        } else if (response.body && response.body.ExceptionMessage) {
          this.text1 = response.body.ExceptionMessage
        } else {
          this.text1 = 'Service Unavailable'
        }

        this.snackbar = true
      })
    },

    downloadReceiptPdf(params, ba) {
      this.$http.post(auth.API_URL + 'api/CurrentMovement/ReceiptPdf', params, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        },
        responseType: 'blob'
      }).then((response) => {
        var blob = new Blob([response.body], {
          type: 'application/pdf'
        })

        var link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = ba == 'A' ? 'TahsilatMakbuzu.pdf' : 'TediyeMakbuzu.pdf'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      }, () => {
        this.text1 = 'Makbuz PDF indirilemedi.'
        this.snackbar = true
      })
    },

    loadDefinitions() {
      var credentials = JSON.parse(window.localStorage.getItem('credentials'))
      var params = {
        CompanyCode: credentials.SirketKodu
      }

      this.$http.post(auth.API_URL + 'api/doctype/List', params, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {
        this.evraktipi = response.body || []
      })

      this.$http.post(auth.API_URL + 'api/currency/List', params, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {
        this.doviztipi = response.body || []
      })

      this.loadBankPosList()
    },

    loadBankPosList() {
      var credentials = JSON.parse(window.localStorage.getItem('credentials'))
      var params = {
        CompanyCode: credentials.SirketKodu
      }

      return this.$http.post(auth.API_URL + 'api/BankPos/List', params, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {
        this.bankapositems = response.body || []
        return this.bankapositems
      }, (response) => {
        if (response && response.status === 0) {
          this.text1 = 'Service Unavailable-bankpos'
        } else if (response && response.body && response.body.ResponseMessage) {
          this.text1 = this.$t(response.body.ResponseMessage)
        } else {
          this.text1 = 'Service Unavailable-bankpos'
        }

        this.snackbar = true
        return []
      })
    }
  },

  mounted() {
    this.loadDefinitions()
  },

  components: {
    parainput,
    tarihim,
    cariaracomp,
    bankakodu,
    kredikartcomp,
    masrafmerkezicomp,
    referansmerkezicomp,
    muhasebekoducomp
  }
}
</script>

<style scoped>
.bank-code-add-row {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
}

.bank-code-field {
  flex: 1 1 auto;
  min-width: 0;
}

.bank-code-add-button {
  flex: 0 0 auto;
  margin: 0 0 2px 0 !important;
}

.pos-code-add-row {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
}

.pos-code-field {
  flex: 1 1 auto;
  min-width: 0;
}

.pos-code-add-button {
  flex: 0 0 auto;
  margin: 0 0 2px 0 !important;
}

.modern-payment-dialog {
  background: #f6f8fb;
  border-radius: 14px;
}

.modern-dialog-header {
  padding: 20px 24px;
  background: #ffffff;
}

.modern-dialog-body {
  padding: 20px 24px;
  background: #f6f8fb;
}

.modern-dialog-actions {
  padding: 14px 24px;
  background: #ffffff;
}

.modern-section-card {
  background: #ffffff;
  border-radius: 14px;
  padding: 18px;
  margin-bottom: 14px;
  box-shadow: 0 2px 10px rgba(20, 35, 60, 0.08);
}

.modern-section-title {
  font-size: 15px;
  font-weight: 700;
  color: #263238;
}

.modern-section-subtitle {
  font-size: 12px;
  color: #78909c;
  margin-top: 3px;
}

.modern-toggle-group {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
}

.modern-operation-item {
  min-width: 150px;
  padding: 12px 16px;
  border-radius: 12px;
  background: #f4f6f8;
  color: #607d8b;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-weight: 600;
  transition: all 0.18s ease;
}

.modern-operation-item:hover {
  background: #e3f2fd;
  color: #1976d2;
}

.modern-operation-item-active {
  background: #1976d2;
  color: #ffffff;
  box-shadow: 0 6px 14px rgba(25, 118, 210, 0.25);
}

.modern-operation-item-active .v-icon {
  color: #ffffff !important;
}

.modern-payment-method-card {
  min-height: 92px;
  border-radius: 14px;
  padding: 16px;
  margin: 6px;
  background: #f8fafc;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 14px;
  transition: all 0.18s ease;
  border: 1px solid transparent;
}

.modern-payment-method-card .v-icon {
  font-size: 32px;
  color: #78909c;
}

.modern-payment-method-card:hover {
  background: #eef6ff;
  border-color: #bbdefb;
  transform: translateY(-1px);
}

.modern-payment-method-card-active {
  background: #e3f2fd;
  border-color: #1976d2;
  box-shadow: 0 6px 16px rgba(25, 118, 210, 0.18);
}

.modern-payment-method-card-active .v-icon {
  color: #1976d2 !important;
}

.modern-payment-title {
  font-size: 15px;
  font-weight: 700;
  color: #263238;
}

.modern-payment-subtitle {
  font-size: 12px;
  color: #78909c;
  margin-top: 3px;
}

.modern-extra-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
}

.modern-extra-content {
  margin-top: 16px;
}

.fill-height {
  height: 100%;
}

.mt-3 {
  margin-top: 12px;
}

.mb-2 {
  margin-bottom: 8px;
}

.mb-3 {
  margin-bottom: 12px;
}

@media (max-width: 768px) {
  .modern-toggle-group {
    justify-content: flex-start;
    margin-top: 12px;
  }

  .modern-operation-item {
    min-width: auto;
    flex: 1;
  }

  .modern-payment-method-card {
    min-height: 76px;
  }
}
</style>